import React from "react";
import { Box, Container, Grid } from "@mui/material";
import {
  HeroSection,
  ContactMethods,
  ContactForm,
  ProcessSteps,
} from "../components/contact";

function Contact() {
  return (
    <Box>
      <HeroSection />

      <Container sx={{ py: 6 }}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={5}>
            <ContactMethods />
          </Grid>

          <Grid item xs={12} md={7}>
            <ContactForm />
          </Grid>
        </Grid>

        <ProcessSteps />
      </Container>
    </Box>
  );
}

export default Contact;
